import React from 'react';
import { WxbIcon } from '../Icon/Icon';
import './Tag.css';

export type WxbTagColor = 'blue' | 'green' | 'amber' | 'red' | 'neutral' | 'cyan';

export interface WxbTagProps extends React.HTMLAttributes<HTMLSpanElement> {
  color?: WxbTagColor;
  closable?: boolean;
  onClose?: (e: React.MouseEvent) => void;
  icon?: React.ReactNode;
}

export const WxbTag: React.FC<WxbTagProps> = ({
  color = 'neutral',
  closable = false,
  onClose,
  icon,
  children,
  className = '',
  ...props
}) => (
  <span className={`wxb-tag wxb-tag-${color} ${className}`} {...props}>
    {icon && <span className="wxb-tag-icon">{icon}</span>}
    <span className="wxb-tag-text">{children}</span>
    {closable && (
      <button
        type="button"
        className="wxb-tag-close"
        aria-label="关闭标签"
        onClick={(e) => { e.stopPropagation(); onClose?.(e); }}
      >
        <WxbIcon name="close" size={12} />
      </button>
    )}
  </span>
);
